@if (visible()) {
<button
  type="button"
  class="app-back-button"
  title="Volver a la vista anterior"
  aria-label="Volver a la vista anterior"
  (click)="volver()"
>
  <i class="fa fa-arrow-left" aria-hidden="true"></i>
</button>
}
